<template>
  <div>
    <div v-if="camapignActive" style="position: relative">
      <div class="container participa-wrapper">
        <paragraph :text="`<h1>Pasii pentru participare</h1>`" />
        <div class="steps">
          <steps-horizontal
            :steps="steps"
            :textColor="color"
            :campaign="campaign"
            :borderColor="borderColor"
          />
        </div>

        <div
          class="d-flex justify-content-center"
          style="padding: 0px 0 120px"
        >
          <button-component
            text="PARTICIPA"
            :styles="{
              width: '180px;',
              'max-width': '180px;',
              'max-height': '60px;'
            }"
            :addClass="buttonClass"
            :action="{ fn: 'goToPage', params: nextPage }"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container participa-wrapper">
        <div class="campaignOver row">
          <div class="col-12">
            <paragraph
              :text="`<h2>Campania s-a incheiat. <br /> Va multumim pentru participare!</h2>`"
            />
            <div class="text-center">
              <div class="contant_box_404">
                <button-component
                  text="Vezi Castigatori"
                  :action="{
                    anchor: true,
                    link: `/${campaign}/castigatori`,
                    targetBlank: true
                  }"
                  :addClass="buttonClass"
                />
                <p>
                  Vezi
                  <a
                    :href="`/files/${campaign}Regulament.pdf`"
                    target="_blank"
                    style="
                      text-decoration: underline;
                      text-underline-position: under;
                    "
                    >Regulamentul campaniei</a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "./button-component.vue";
import paragraph from "./paragraph.vue";
import StepsHorizontal from "./steps-horizontal.vue";

export default {
  components: { paragraph, StepsHorizontal, ButtonComponent },
  name: "participa",
  props: {
    color: {
      type: String,
      default: "#f2ac29"
    },
    borderColor:{
      type: String,
      default: "#ebf0fa"
    },
    buttonClass: {
      type: String,
      default: ""
    },
    steps: {
      type: Array,
      default: () => []
    },
    nextPage: {
      type: String,
      default: ""
    },
    campaign: {
      type: String,
      default: ""
    }
  },
  computed: {
    camapignActive() {
      const startDate = new Date(
        new Date(this.$store.state.campaignStartDate).setHours(0, 0, 0, 0)
      ).toLocaleString("en-US");
      const endDate = new Date(
        new Date(this.$store.state.campaignEndDate).setHours(0, 0, 0, 0)
      ).toLocaleString("en-US");
      const currentTime = new Date().toLocaleString("en-US", {
        timeZone: "Europe/Bucharest"
      });
      const dayInSeconds = 86400; // If we need to include the ending day
      const isTestVersion = this.$route.query.version === "test";

      return (
        isTestVersion ||
        (new Date(startDate).getTime() / 1000 <=
          new Date(currentTime).getTime() / 1000 &&
          new Date(endDate).getTime() / 1000 + dayInSeconds >=
            new Date(currentTime).getTime() / 1000)
      );
    }
  }
};
</script>
<style lang="scss">
.participa-wrapper {
  position: static;

  h1 {
    margin-top: 20px;
  }

  .steps {
    padding: 70px 0;

    @media (max-width: 767px) {
      padding: 50px 0 30px;
    }
  }
}

.campaignOverWrapper {
  margin-top: 40px;

  @media (max-width: 767px) {
    margin-top: 20px;
    margin-bottom: 0 !important;
  }
}

.decoration {
  position: absolute;
}

.page_404 img {
  width: 100%;
}

.contant_box_404 {
  p {
    font-size: 18px;
    padding-bottom: 130px;
    color: #081821;

    @media (max-width: 767px) {
      font-size: 16px;
    }
  }

  button {
    margin-top: 60px;
    margin-bottom: 20px;

    @media (max-width: 767px) {
      margin-top: 30px;
    }
  }
}

.link_404 {
  color: #fff !important;
  padding: 10px 20px;
  background: #39ac31;
  margin: 20px 0;
  display: inline-block;
}

.campaignOver {
  h2 {
    line-height: 40px;
    margin-top: 30px;
    margin-bottom: 20px;

    @media (max-width: 767px) {
      line-height: 30px;
      font-size: 22px;
    }
  }
}
</style>
